"use strict";

/** Universal Toggler for Drawers, Accordions, etc. **/
class ClassToggler {
  constructor(triggerSelector, targetsSelector, className = 'rdc-active') {
    this.triggers = document.querySelectorAll(`${triggerSelector}`);
    this.targets = document.querySelectorAll(`${targetsSelector}`);
    this.className = className;
    this.init();
    
  }

  init() {
    this.triggers.forEach(trigger => {
      const targetSelector = trigger.getAttribute('data-target');
      const target = document.querySelector(`.${targetSelector}`);
         
       
      if (target) {
        trigger.addEventListener('click', () => {
          
          const isActive = target.classList.contains(this.className);

          // If multiple triggers (e.g. accordion), close all first
          if (this.triggers.length > 1) {
            this.targets.forEach(t => t.classList.remove(this.className));
            this.triggers.forEach(t => t.classList.remove(this.className));
          // If target wasn't active, activate it (otherwise leave it closed)
          if (!isActive || trigger.classList.contains('rdc-no-toggle')) {
            target.classList.add(this.className);
            trigger.classList.add(this.className);
            if (target.querySelector('.rdc-child-toggle')) {
              const childToggles = target.querySelectorAll('.rdc-child-toggle');
             childToggles.forEach(childToggle => {
               childToggle.children[0].classList.add('rdc-active');
             })
            }
          }
          } else {
            target.classList.toggle(this.className);
          }

          
        });
      }
    });
  }
}

new ClassToggler('.cromenu2025-main_title','.cromenu2025-main_links','rdc-active');
new ClassToggler('.cromenu2025-toggle ','.cro-menu-2025','rdc-active');

/**Featured Products**/
new ClassToggler('.hys-feat-prods-disp-btn','.hys-feat-prods-disp-item','rdc-active');
new ClassToggler('.hys-fp-th','.hys-fp-med','rdc-active');

/**Warranty Modal**/
new ClassToggler('.lifetime-warranty-btn','#hys-warr-modal','rdc-active');

/**Close a Modal and Scroll to Section**/

const clsModalScrollSection = function () {
  const elToClose = document.querySelector(`#${this.dataset.main}`);
  const target = document.querySelector(`#${this.dataset.target}`);
  elToClose.classList.remove('rdc-active');
  target.scrollIntoView({
    behavior: 'smooth'
  });
}

const modalWarrantyClose = document.querySelector('#warr-modal-cls-btn');
if(modalWarrantyClose) modalWarrantyClose.addEventListener('click',clsModalScrollSection);



/**Hide excess cards from the CRO menu**/

const menuCollUls = document.querySelectorAll('.cromenu2025-collection');

menuCollUls.forEach(menuCollUl => {
  const cardLimit = menuCollUl.dataset.limit;
  const menuCollCardsArr = Array.from(menuCollUl.children);
  const collCardCount = menuCollCardsArr.length;

  if(collCardCount > cardLimit) {
    for (let [i, collCard] of menuCollCardsArr.entries()) {
      const index = i+1;
  if(index > cardLimit && !collCard.classList.contains('cromenu2025-link-box')) {
    collCard.classList.add('rdc-d-none');
  }
}
  }
})

// /**Max height setting for the menu collection drawers for smooth animation**/
// const drawerColl1Uls = document.querySelectorAll('.cromenu2025-main_links.rdc-active ul.cromenu2025-collection');
// const drawerColl2Uls = document.querySelectorAll('.cromenu2025-coll-inner.rdc-active ul.cromenu2025-collection');
// const drawerCollLi = document.querySelectorAll('.cromenu2025-main_links.rdc-active ul.cromenu2025-collection li');

// const setMaxHeight = function (els) {
//  els.forEach(el => {
//   const childCount = Array.from(el.children).length;
//   const rowCount = Math.trunc(childCount/3);
//   const setHeight = Array.from(drawerCollLi)[0].clientHeight * rowCount;

//    console.log(setHeight)
//   drawerColl1Ul.style.maxHeight = `${setHeight}px`;
// })
// }

// setMaxHeight(drawerColl1Uls);
// setMaxHeight(drawerColl2Uls);



const accBtns = document.querySelectorAll('.guide-video-acc');

if (accBtns[0]) {
  accBtns.forEach(accBtn => {
    accBtn.addEventListener('click', function () {
      const thisVideo = this.parentElement.parentElement.querySelector('.video');
      const isOpen = !!thisVideo.src; // check if video is currently open/playing

      // Remove all video srcs first
      const videos = document.querySelectorAll('.video');
      videos.forEach(video => {
        video.removeAttribute('src');
      });

      // If it wasn't open, play this one
      if (!isOpen) {
        thisVideo.src = thisVideo.dataset.src;
      }

    });
  });
}

/** 
// Hyspecs Mobile Product Gallery Swipe
if (window.matchMedia('(max-width: 768px)').matches) {
  const gallery = document.querySelector('.hys-prod-gallery-imgs');
  const images = Array.from(gallery.querySelectorAll('.hys-prod-gallery-img'));
  let startX = 0;
  let currentIndex = 0;

  // Disable native scrolling
  gallery.style.overflow = 'hidden';
  gallery.style.display = 'flex';
  gallery.style.scrollBehavior = 'auto';

  // --- Swipe handling ---
  gallery.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  gallery.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const dx = endX - startX;
    const threshold = 40; // minimum swipe distance

    if (dx < -threshold && currentIndex < images.length - 1) {
      currentIndex++; // next image
    } else if (dx > threshold && currentIndex > 0) {
      currentIndex--; // prev image
    }

    goToIndex(currentIndex);
  });

  // --- Function to move slider ---
  function goToIndex(index) {
    currentIndex = index;
    let offset = 0;
    for (let i = 0; i < index; i++) {
      offset += images[i].offsetWidth;
    }
    gallery.style.transform = `translateX(${-offset}px)`;
    gallery.style.transition = 'transform 0.3s ease';
  }

  // --- Swatch click handling ---
  const swatches = document.querySelectorAll('variant-swatch');
  swatches.forEach((swatch) => {
    swatch.addEventListener('click', () => {
      swatch.parentElement.parentElement.children[0].checked = 'false';

      const mediaId = swatch.innerText;
      const targetIndex = images.findIndex(img => mediaId.includes(img.children[0].dataset.var));
      if (targetIndex !== -1) {
        swatch.parentElement.parentElement.children[0].checked = 'true';
        goToIndex(targetIndex);
        
      }
    });
  });

  // --- On page load: show correct image for pre-selected swatch ---
window.addEventListener('DOMContentLoaded', () => {
  const checkedSwatch = Array.from(document.querySelectorAll('variant-swatch')).find(swatch => {
    const input = swatch.parentElement.parentElement.children[0];
    return input && input.checked;
  });

  if (checkedSwatch) {
    const mediaId = checkedSwatch.innerText;
    const targetIndex = images.findIndex(img => mediaId.includes(img.children[0].dataset.var));
    if (targetIndex !== -1) {
      goToIndex(targetIndex);
    }
  }
});
}
**/

// const laModal = document.querySelector('#lensadvizor-prescription-modal');

// setTimeout(() => {
//   const lensAdBtn = document.querySelector('#la-select-lenses-btn');
//   if (!lensAdBtn) return;

//   const openPd = () => {
//     console.log('rdc-pd');
//   };

//   const attachInfoIcon = () => {
//     const infoIcon = document.querySelector(
//       '.la-prescription-wrapper .la-wrapper-heading h3'
//     );

//     if (!infoIcon || infoIcon.dataset.pdAttached) return;

//     infoIcon.addEventListener('click', openPd);
//     infoIcon.dataset.pdAttached = 'true';
//   };

//   const attachLabelListeners = () => {
//     const laLabels = document.querySelectorAll('.la-label-btn-wrapper');
//     if (!laLabels.length) return;

//     laLabels.forEach(label => {
//       if (label.dataset.pdAttached) return;

//       label.addEventListener('click', () => {
//         console.log('pd-next');

//         // wait for UI transition / injection
//         setTimeout(attachInfoIcon, 500);
//       });

//       label.dataset.pdAttached = 'true';
//     });
//   };

//   const pdModal = () => {
//     // allow app to render labels
//     setTimeout(attachLabelListeners, 1000);
//   };

//   lensAdBtn.addEventListener('click', pdModal);
// }, 2000);


// Variant Swatches Update Fix - this is a fix to: not updating the text when a color is selected

const colorVars = document.querySelectorAll('variant-swatch');
if(colorVars[0]) {
const colorText = document.querySelector('.product-form__swatch__sub-title');

const updateVarColorText = function () {
  const colorSelected = this.getAttribute('swatch-id').replace('-',' ');
  colorText.innerText = `${colorSelected.toUpperCase()}`;
};

colorVars.forEach(colorVar => {
  colorVar.addEventListener('click',updateVarColorText)
});
};